import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Icons } from '../../../../../assets/imgs/icons';
import { useFormik } from 'formik';
import { signupInitialValues, signupSchema } from '../../../Extras/AuthenticationFormik';
import showToast from '../../../../../Shared/Utils/ToastNotification';
import Service from '../services/Service';
import { useSelector, useDispatch } from 'react-redux';
import { setPendingEmail } from '../../../../../Shared/Slice/AuthSlice';
import img1 from '../../../../../assets/imgs/0a8f62242ec799f152866e747fa102562420968c.png';
import img2 from '../../../../../assets/imgs/0ce5c8b58d533e324615a59d7f991dd3977bd4b3.jpg';
import img3 from '../../../../../assets/imgs/1fe0554d501cb3c912ebad3f44b26392392df6a0.png';
import img4 from '../../../../../assets/imgs/09bdaab1a2034e127e45ce747d211455d4d06b6a.jpg';
import img5 from '../../../../../assets/imgs/8858e91672837f1ec1cf70fb12151be8cfd7f945.jpg';
import brandlogo from '../../../../../assets/imgs/swimscore-logo.png';

const Signup = () => {
  const { id } = useParams(); // id will be '2531687'

  const loginImages = [img1, img2, img3, img4, img5];

  // Randomly select initial image
  const [currentImageIndex, setCurrentImageIndex] = useState(() => Math.floor(Math.random() * loginImages.length));

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPass, setShowPass] = useState(false);
  const [showCPass, setShowCPass] = useState(false);
  const isLoading = useSelector((state) => state.loader.signup);

  // Rotate images every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % loginImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [loginImages.length]);

  // 🔥 new states for dynamic logic
  const [shopifyId, setShopifyId] = useState(null);
  const [isEmailEditable, setIsEmailEditable] = useState(true);
  const [isPhoneEditable, setIsPhoneEditable] = useState(true);

  const formik = useFormik({
    initialValues: {
      ...signupInitialValues,
    },
    validationSchema: signupSchema,
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: async (values) => {
      try {
        const payload = {
          email: values.email,
          password: values.password,
          confirm_password: values.confirm_password,
          phone_number: values.phone_number,
          shopify_customer_id: shopifyId, // ✅ dynamic from API
        };
        const res = await Service.signup(payload);
        if (res?.data) {
          showToast('success', 'Registration successful! OTP sent to your email.');
          dispatch(setPendingEmail({ email: values.email, justRegistered: true }));
          navigate('/otp-verification');
        }
      } catch (err) {
        const message = err.response?.data?.message || err.response?.data?.errors?.[0] || 'Registration failed';
        showToast('error', message);
      }
    },
  });

  const error = (name) => (formik.touched[name] && formik.errors[name] ? <div className="error">{formik.errors[name]}</div> : null);

  // 🔥 Fetch patient data dynamically
  // useEffect(() => {
  //   const fetchPatient = async () => {
  //     try {
  //       // 🧩 Now we fetch using shopify_customer_id, not email
  //       const shopifyCustomerId = id; // or get dynamically from URL/sessionStorage/props

  //       const res = await Service.getPatientByEmail(shopifyCustomerId);

  //       if (res?.data?.patient) {
  //         const p = res.data.patient;

  //         // 🧩 save Shopify ID for signup payload
  //         setShopifyId(p.shopify_customer_id || null);

  //         // 🧩 set autofill values
  //         formik.setValues({
  //           ...formik.values,
  //           firstname: p.first_name || '',
  //           lastname: p.last_name || '',
  //           email: p.email || '',
  //           phone_number: p.phone_number || '',
  //           dob: '',
  //           preferred_name: '',
  //           password: '',
  //           confirm_password: '',
  //         });

  //         // 🧩 dynamic field editability
  //         setIsEmailEditable(!p.email); // editable if missing
  //         setIsPhoneEditable(!p.phone_number); // editable if missing
  //       }
  //     } catch (err) {
  //       showToast('error', 'Failed to load patient info');
  //     }
  //   };

  //   fetchPatient();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {
    const fetchPatient = async () => {
      // // Only fetch patient data if id is provided
      if (!id) {
        return;
      }

      try {
        const shopifyCustomerId = id; // from URL param
        const res = await Service.getPatientByEmail(shopifyCustomerId);

        if (res?.data?.patient) {
          const p = res.data.patient;

          // 🧩 If patient is already active, redirect them
          if (p.is_active) {
            navigate('/'); // 👈 redirect to home page
            return; // stop executing rest
          }

          // 🧩 save Shopify ID for signup payload
          setShopifyId(p.shopify_customer_id || null);

          // 🧩 set autofill values
          formik.setValues({
            ...formik.values,
            firstname: p.first_name || '',
            lastname: p.last_name || '',
            email: p.email || '',
            phone_number: p.phone_number || '',
            dob: '',
            preferred_name: '',
            password: '',
            confirm_password: '',
          });

          // 🧩 dynamic field editability
          setIsEmailEditable(!p.email); // editable if missing
          setIsPhoneEditable(!p.phone_number); // editable if missing
        }
      } catch (err) {
        showToast('error', 'Failed to load patient info');
      }
    };

    fetchPatient();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="login">
        <div className="login-content">
          <img className="login-video" src={loginImages[currentImageIndex]} alt="Login background" />
          <div className="logo">
            <img src={brandlogo} alt="" />
          </div>
        </div>
        <div className="login-form loginpage">
          <div className="login-head">
            <h2>Sign up</h2>
          </div>

          <form onSubmit={formik.handleSubmit} noValidate>
            <div className="form_col">
              <div className="form-group">
                <label>
                  First Name <span className="require">*</span>
                </label>
                <input
                  className={`form-control${error('firstname') ? ' is-invalid' : ''}`}
                  type="text"
                  placeholder="Enter your first name"
                  name="firstname"
                  value={formik.values.firstname}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {error('firstname')}
              </div>

              <div className="form-group">
                <label>
                  Last Name <span className="require">*</span>
                </label>
                <input
                  className={`form-control${error('lastname') ? ' is-invalid' : ''}`}
                  type="text"
                  placeholder="Enter your last name"
                  name="lastname"
                  value={formik.values.lastname}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {error('lastname')}
              </div>
            </div>

            <div className="form_col">
              <div className="form-group">
                <label>
                  Email <span className="require">*</span>
                </label>
                <input
                  className={`form-control${error('email') ? ' is-invalid' : ''}`}
                  type="email"
                  placeholder="Enter your email"
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  readOnly={!isEmailEditable} // 🔥 editable if missing
                />
                {error('email')}
              </div>

              <div className="form-group">
                <label>
                  Phone Number <span className="require">*</span>
                </label>
                <input
                  className={`form-control${error('phone_number') ? ' is-invalid' : ''}`}
                  type="text"
                  placeholder="Enter your phone number"
                  name="phone_number"
                  value={formik.values.phone_number}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  readOnly={!isPhoneEditable} // 🔥 editable if missing
                />
                {error('phone_number')}
              </div>
            </div>

            <div className="form_col">
              <div className="form-group pass">
                <label>
                  Password <span className="require">*</span>
                </label>
                <input
                  className={`form-control${error('password') ? ' is-invalid' : ''}`}
                  type={showPass ? 'text' : 'password'}
                  placeholder="********"
                  name="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <button type="button" className="eye-toggle" onClick={() => setShowPass(!showPass)}>
                  {showPass ? <Icons.EyeOpen className="eye open" /> : <Icons.EyeClose className="eye close" />}
                </button>
                {error('password')}
              </div>

              <div className="form-group pass">
                <label>
                  Confirm Password <span className="require">*</span>
                </label>
                <input
                  className={`form-control${error('confirm_password') ? ' is-invalid' : ''}`}
                  type={showCPass ? 'text' : 'password'}
                  placeholder="********"
                  name="confirm_password"
                  value={formik.values.confirm_password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <button type="button" className="eye-toggle" onClick={() => setShowCPass(!showCPass)}>
                  {showCPass ? <Icons.EyeOpen className="eye open" /> : <Icons.EyeClose className="eye close" />}
                </button>
                {error('confirm_password')}
              </div>
            </div>

            <button className="btn" type="submit" disabled={formik.isSubmitting || !formik.isValid || isLoading}>
              {isLoading ? 'Registering...' : 'Register'}
            </button>
          </form>

          {/* <p className="login-bottom-text">Your data is processed securely and handled in line with applicable regulations.</p> */}
        </div>
      </div>
    </>
  );
};

export default Signup;
